<template>
  <reservation-component mode="reserve"></reservation-component>
</template>

<script>
import ReservationComponent from "./ReservationComponent.vue";
export default {
  components: {
    ReservationComponent: ReservationComponent,
  },
};
</script>

<style scoped></style>
